export const is = 'is';
export const contains = 'contains';
export const doesNotContain = 'does not contain';
export const isNot = 'is not';
export const isOneOf = 'is one of';
export const isNotOneOf = 'is not one of';
export const isNotNull = 'is not null';

export const greaterOrEqual = 'gte';
export const greater = 'gt';
export const lessOrEqual = 'lte';
export const less = 'lt';
export const equal = 'eq';
export const notEqual = 'neq';
export const allowAnyValue = 'allow any value';

export const textOperators = [is, contains, doesNotContain, isNotNull];
export const dateOperators = [is, less, greater];
export const numberOperators = [equal, greater, less, greaterOrEqual, lessOrEqual];

export const validOperators = [
    contains,
    doesNotContain,
    is,
    isNot,
    isOneOf,
    isNotOneOf,
    isNotNull,
    greaterOrEqual,
    greater,
    lessOrEqual,
    less,
    equal,
    notEqual,
    allowAnyValue,
];

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('operators', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
